import React from "react";
import { Card, Table } from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";

function EntitiesTable({ entities, ...props }) {
  return (
    <Table responsive size="sm">
      <thead>
        <tr>
          <th>Text</th>
          <th>Type</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        {entities.map((entity, index) => {
          return (
            <tr key={`entity_${index}`}>
              <td>{entity.Text}</td>
              <td>{entity.Type}</td>
              <td>{parseFloat(entity.Score).toFixed(3)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
function SentimentScore({ title, score, ...props }) {
  return (
    <div>
      <div> {title}:</div>
      <RangeSlider onChange={() => {}} value={score} max={10} />
    </div>
  );
}
export default function AnalysisResult({ result, ...props }) {
  return result && result.result && result.result.analysis ? (
    <Card className="mt-2">
      <Card.Body>
        <div className="h6 font-weight-bold">Analysis Result</div>
        <p>
          <span className="font-weight-bold mr-1">Text:</span>
          {result.text}{" "}
        </p>
        <div>
          <span className="font-weight-bold mr-1">Metal:</span>
          {result.result.metal}
        </div>
        <div>
          <span className="font-weight-bold mr-1">Sentiment:</span>
          {result.result.analysis.Sentiment}
        </div>
        <div>
          <SentimentScore
            title="Negative sentiment score"
            score={result.result.analysis.SentimentScore.Negative}
          />
          <SentimentScore
            title="Neutral sentiment score"
            score={result.result.analysis.SentimentScore.Neutral}
          />
          <SentimentScore
            title="Positive sentiment score"
            score={result.result.analysis.SentimentScore.Positive}
          />
        </div>
        <div>
          <hr />
          <p className="font-weight-bold mr-1">Entities:</p>
          {result.result.entities ? (
            <EntitiesTable entities={result.result.entities} />
          ) : (
            <div>No entities found</div>
          )}
        </div>
      </Card.Body>
    </Card>
  ) : null;
}
